// extracted by mini-css-extract-plugin
module.exports = {"page":"profile-page_page__1GK61","pageContent":"profile-page_pageContent__20CyN","main":"profile-page_main__1IKQG","mainContent":"profile-page_mainContent__zWV1Q"};